import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class CheckupService extends BaseService{

  getCheckUps(){
    const url = `${environment.portalApi}/CheckUp/GetCheckUps?cpf=` + this.tokenService.getActiveUser().cpf;
    return this.http.get(url, { headers: this.createHeader() });
  }

  generatePDF(cpf:any){
    const url = `${environment.portalApi}/CheckUp/GeneratePDF?cpf=` + cpf;
    return this.http.get(url, { headers: this.createHeader(), responseType: 'blob'  });
  }

}
